import DailyTemperature from "./DailyTemperature";

export default DailyTemperature;